function PayTypes() {
    return (
      <>
        <div className="font-bold text-lg mb-16">PayTypes</div>
      </>
    );
  }
  
  export default PayTypes;